import { Component, Input } from '@angular/core';
/**
 * Generated class for the SectorEbitChartComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'sector-ebit-chart',
  templateUrl: 'sector-ebit-chart.html'
})
export class SectorEbitChartComponent {
  @Input() sectors: {};

  text: string;

  constructor() {
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/sector-ebit-chart/sector-ebit-chart.ts